module.exports = __webpack_public_path__ + "static/media/price-3.4e01b245.svg";